"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20ContractDeployButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const deployERC20Token_json_1 = __importDefault(require("@framework/abis/json/ERC20FactoryFacet/deployERC20Token.json"));
const constants_1 = require("@framework/constants");
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./dialog/validation");
const Erc20ContractDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployERC20Token_json_1.default,
            functionName: "deployERC20Token",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                {
                    contractTemplate: Object.values(types_1.Erc20ContractTemplates).indexOf(values.contractTemplate).toString(),
                    name: values.name,
                    symbol: values.symbol,
                    cap: BigInt(values.cap),
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/erc20",
            method: "POST",
            data,
        }, form);
    };
    const handleDeploy = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ERC20_CONTRACT_DEPLOY, {}, {
            initialValues: {
                contractTemplate: types_1.Erc20ContractTemplates.SIMPLE,
                name: "",
                symbol: "",
                cap: (constants_1.WeiPerEther * BigInt(1e6)).toString(),
            },
            message: "dialogs.deploy",
            testId: "Erc20ContractDeployForm",
            validationSchema: validation_1.erc20ContractDeployValidationSchema,
            onExternalConfirm: onDeployConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "Erc20ContractDeployButton", disabled: disabled, variant: variant }));
};
exports.Erc20ContractDeployButton = Erc20ContractDeployButton;
//# sourceMappingURL=index.js.map